export enum RoleType {
  consultant = 1, //1:育儿顾问，
  specialist = 3, //3育儿专家，
  manager, //4：店长，
  nurseryTeacher = 99 //99：育儿师
}

/**
 * 券类型（1-满减券 2-现金券 3 折扣券）
 */
export enum CouponType {
  fullReduction = 1,
  cash,
  discount
}

/**
 * 优惠类型 3-秒杀 4-拼团 5-立减 6满赠
 */
export enum PromotionType {
  seckill = 3,
  group = 4,
  subtract = 7,
  present = 8
}

/**
 * 异步数据状态
 */
export enum AsyncStatus {
  unDef, // 未定义
  NO, //没有值
  HAS //有值
}
